module.exports = __webpack_public_path__ + "img/main-image.91a64c37.jpeg";